import { z } from 'zod';
import { DefaultTestLanguageFirstOption } from '../../Create/Contexts/CreateRecruitmentContextState';
import { TestTypes } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';

export const selectTestsSchema = z
    .object({
        isAptitudeSelected: z.boolean(),
        isEmotionalIntelligenceSelected: z.boolean(),
        isSkillsSelected: z.boolean(),
        isPersonalitySelected: z.boolean(),
        testLanguageField: z.string().min(2),
    })
    .superRefine((values, ctx) => {
        const hasTest =
            values.isAptitudeSelected ||
            values.isEmotionalIntelligenceSelected ||
            values.isSkillsSelected ||
            values.isPersonalitySelected;

        if (!hasTest) {
            ctx.addIssue({
                code: 'custom',
                message: UIStrings.PleaseSelectAtLeastOneTestToContinue,
                path: ['isAptitudeSelected'],
            });
        }
    });

export type SelectTestsFormValues = z.infer<typeof selectTestsSchema>;

export const defaultSelectTestsFormValues: SelectTestsFormValues = {
    isAptitudeSelected: false,
    isEmotionalIntelligenceSelected: false,
    isSkillsSelected: false,
    isPersonalitySelected: false,
    testLanguageField: DefaultTestLanguageFirstOption,
};

export function buildDefaultValuesFromContext(includedTests: TestTypes[], testLanguage: string): SelectTestsFormValues {
    const hasTest = (test: TestTypes) => includedTests.includes(test);

    return {
        isAptitudeSelected: hasTest(TestTypes.Aptitude),
        isEmotionalIntelligenceSelected: hasTest(TestTypes.EmotionalIntelligence),
        isSkillsSelected: hasTest(TestTypes.Skills),
        isPersonalitySelected: hasTest(TestTypes.Personality),
        testLanguageField: testLanguage,
    };
}
